import Section from "~/components/Section";
import Container from "~/components/Container";
import Page from "~/components/Page";
import {A, createAsync} from "@solidjs/router";
import {For, Show, Suspense} from "solid-js";
import css from "./classes.module.css"
import {Class} from "@gs-yoga/sdk/types";
import {getClasses} from "~/sdk/class";
import {formatDate} from "date-fns";
import FilterBuilder, {FilterOperator} from "@gs-yoga/sdk/filter";

export default function Classes() {

    const filter = new FilterBuilder(1, 100).filter("starts_at", FilterOperator.Gte, new Date().toISOString()).build()

    const classes = createAsync(() => getClasses(filter))

    return (
        <Page
            metaTitle="Upcoming Yoga Classes in Catshill"
            metaDescription="Browse our schedule of Vinyasa flow classes at Catshill Village Hall, Bromsgrove. Reserve your spot online with Graceful Space Yoga.">
            <Section>
                <Container>
                    <h1>Classes</h1>
                    <Suspense>
                        <Show when={classes()?.records?.length === 0}>
                            <p>There are no classes available</p>
                        </Show>
                        <GroupedClassList classes={classes()?.records}/>
                    </Suspense>
                </Container>
            </Section>
        </Page>
    )
}

export function GroupedClassList(props: { classes?: Class[] }) {
    const groupedClasses = () => {
        const map = new Map<string, Class[]>();
        props.classes?.forEach((c) => {
            const dateKey = new Date(c.startsAt).toDateString();
            if (!map.has(dateKey)) {
                map.set(dateKey, []);
            }
            map.get(dateKey)!.push(c);
        });
        return Array.from(map.entries()).map(([date, classes]): [string, Class[]] => [
            date,
            classes.sort((a, b) => new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime()),
        ]);
    };

    return (
        <div class={css.groupedClassList}>
            <For each={groupedClasses()}>
                {([date, classes]) => (
                    <div class={css.date}>
                        <h2 class={css.dateTitle}>{formatDate(new Date(date), 'EEE, dd MMM yyyy')}</h2>
                        <div class={css.classes}>
                            <For each={classes}>
                                {(c) => (
                                    <A href={`/classes/${c.id}`} class={css.class}>
                                        <h3>{c.name}</h3>
                                        <Show when={c.id === "cDXdYZm7pFYYG4Eus0T9l"}>
                                            {/*    Temporary for christmas class */}
                                            <p class={css.canceled}>No spaces remaining</p>
                                        </Show>
                                        <p>{c.location?.name}</p>
                                        <Show when={!c.canceledAt}
                                              fallback={<p class={css.canceled}>Class unavailable to book</p>}>
                                            <p>£10</p>
                                            <p>{formatDate(new Date(c.startsAt), 'HH:mm')} - {formatDate(new Date(c.endsAt), 'HH:mm')}</p>
                                        </Show>
                                    </A>
                                )}
                            </For>
                        </div>
                    </div>
                )}
            </For>
        </div>
    );
}